import { context, CookieStorageAdapter } from '@wikia/ad-engine';

interface GeoResponse {
	continent_code: string;
	country_code: string;
	region: string;
	city: string;
	country_name: string;
}

interface GeoData {
	continent: string;
	country: string;
	region: string;
}

export async function ensureGeoAvailable(): Promise<void> {
	if (window.ads?.geo !== undefined) {
		setUpGeoData(window.ads.geo);
		return;
	}

	const cookieAdapter = new CookieStorageAdapter();
	const geoCookie = cookieAdapter.getItem('Geo');

	if (geoCookie) {
		try {
			setUpGeoData(JSON.parse(decodeURIComponent(geoCookie)) || {});
			return;
		} catch (e) {
			throw new Error('Invalid JSON in the cookie');
		}
	}

	try {
		return getGeoData().then((geoData) => {
			cookieAdapter.setItem('Geo', encodeURIComponent(JSON.stringify(geoData)));
			setUpGeoData(geoData);
		});
	} catch (e) {
		// do nothing
	}
}

function setUpGeoData(geoData: GeoData) {
	context.set('geo.region', geoData.region);
	context.set('geo.country', geoData.country);
	context.set('geo.continent', geoData.continent);
}

async function getGeoData(): Promise<GeoData> {
	const GEO_SERVICE_URL = 'https://services.fandom.com/geoip/location';

	const response = await fetch(GEO_SERVICE_URL, {
		method: 'GET',
		credentials: 'include',
	});
	const geoResponse: GeoResponse = await response.json();

	return {
		continent: geoResponse.continent_code,
		country: geoResponse.country_code,
		region: geoResponse.region,
	};
}
